module.exports = __webpack_public_path__ + "assets/img/Setup.7e370670.svg";